import React from 'react';

import Pic1 from '../../InstallImages/Inverters/Generac';


const generacLink = <a href="https://www.dropbox.com/s/a094768nplcipon/Generac%20Inverter%20Spec%20Sheet.pdf?dl=0" rel="noopener noreferrer" target="_blank"> Data Sheet</a>;

const Inverter = () => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">

            <p className="specsText">With rising energy costs and environmental threats looming over your head, it may seem like there&#39;s no relief in sight. What you need is a solution that will help you save money, keep your home safe and reduce your carbon footprint. Introducing Generac&#39;s PWRcell - a battery storage system that harnesses power from the sun to help reduce your electric bill and provide backup power during utility power outages.
            </p>
            <p className="specsText">PWRcell&#39;s revolutionary technology captures and stores electricity - either from solar panels, or the electrical grid. It allows you to use stored energy during peak demand times when electricity costs are high, which ultimately helps reduce your electric bill and save some money. In the case of a power outage, PWRcell is ready to supply backup power to your home.
            </p>
            <p className="specsText">Generac is committed to developing a long-term vision that promotes environmentally responsible products, processes, and partnerships. We offer product options that allow our customers to shrink their ecological footprint when backup energy use is required. Manufacturing processes are implemented with the goal of minimizing environmental impact by reducing the amount of materials used and emissions produced. Partnerships are sought with organizations and stakeholders to further the development of sustainable technologies. By adhering to these principles, we strive to be a positive contributor of sustainable growth in our industry.
            </p>
            <ul>
                <li className="specsText">{generacLink}</li>
            </ul>
        </div>
    </div>
);


export default Inverter;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Inverters/generac.js